import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from 'components/AppIcon';
import WhatsAppIcon from 'components/icons/WhatsAppIcon';
import { useAuth } from 'contexts/AuthContext';

const ContactMethodModal = ({ isOpen, onClose }) => {
  const { user, profile } = useAuth();

  const handleWhatsAppClick = () => {
    const phoneNumber = '254793863320';
    const userName = profile?.full_name || user?.displayName || user?.email?.split('@')[0] || 'Student';
    const message = encodeURIComponent(`Hi! I'm ${userName} and I need help with my academic work. I wanted to know what subjects you assist with. Can we chat?`);
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            className="glass-card p-6 rounded-2xl shadow-xl max-w-sm w-full relative"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
          >
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-text-secondary hover:text-text-primary transition-colors"
              aria-label="Close modal"
            >
              <Icon name="X" size={24} />
            </button>

            <h2 className="text-2xl font-bold text-text-primary text-center mb-6">Chat With Us</h2>
            <p className="text-text-secondary text-center mb-8">
              Get instant support through WhatsApp for all your academic needs.
            </p>

            <div className="space-y-4">
              <motion.button
                onClick={handleWhatsAppClick}
                whileHover={{ 
                  scale: 1.02,
                  boxShadow: "0 10px 25px rgba(37, 211, 102, 0.3)"
                }}
                whileTap={{ 
                  scale: 0.98,
                  transition: { duration: 0.1 }
                }}
                className="relative w-full py-4 px-6 bg-gradient-to-r from-[#25D366] to-[#128C7E] hover:from-[#128C7E] hover:to-[#25D366] text-white text-center text-lg font-bold flex items-center justify-center rounded-xl shadow-lg transition-all duration-300 overflow-hidden group"
              >
                <div className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-out"></div>
                <WhatsAppIcon className="mr-3 text-white" size={24} />
                <span className="relative z-10">Chat on WhatsApp</span>
                <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer"></div>
                </div>
              </motion.button>
              
              <div className="text-center">
                <p className="text-text-secondary text-sm">
                  Available 24/7 for instant academic support
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ContactMethodModal;
